<script setup>
import {onMounted, reactive, ref, watch} from "vue";
import {Avatar} from "vue-avatar/src";
import {statuses} from "@/constants/needs";
import needsDashboardService from "@/services/needs-dashboard.service";

const {escalated} = defineProps(['escalated']);

const hasData = ref(null);
const needs = ref([]);
const search = ref('');

const filters = reactive({
    search: '',
})

watch(filters, () => {
    getList();
});

onMounted(() => {
    getList();
});

async function getList() {
    const {data} = await needsDashboardService.getNeedsList(escalated ? 'escalated' : 'not-escalated', filters);
    needs.value = data;

    if (hasData.value === null) {
        hasData.value = !!needs.value.length
    }
}
</script>

<template>
    <div v-if="hasData" class="need-admin__card need-admin__card--round">
        <div class="need-admin__card__inner">
            <header class="need-admin__card__header">
                <h3 class="need-admin__title">
                    {{ escalated ? 'Escalated Needs' : 'Needs in Progress' }}
<!--                    <sup class="need-admin__title__count">6 new</sup>-->
                </h3>
<!--                <a href="#" class="link">View All needs</a>-->
            </header>

            <div class="need-admin__filter">
                <!-- Disable not implemented filters
                <select class="need-admin__select">
                    <option>Status</option>
                </select>
                <select class="need-admin__select">
                    <option>Category</option>
                </select>
                <select class="need-admin__select">
                    <option>User</option>
                </select>
                -->

                <div class="ml-auto">
                    <input type="text" placeholder="Search for a need" class="need-admin__search" v-model="search" v-debounce:500="() => filters.search = search"/>
                </div>
            </div>
        </div>


        <div v-if="needs.length" class="need-admin__table">
            <table>
                <thead>
                <tr>
                    <th>Need</th>
                    <th>Owner</th>
                    <th v-if="escalated">Status</th>
                    <th v-if="!escalated">Recommended</th>
                    <th>Added From AI</th>
                    <th>Added From Ecosystems</th>
                    <th v-if="!escalated">Rated</th>
                    <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="need in needs"
                    :key="need.id"
                >
                    <td>
                        <h6 class="heading6">{{need.name}}</h6>
                        <p v-if="escalated" class="danger">Escalated {{need.escalated_date}}</p>
                    </td>
                    <td>
                    <span v-if="need.user" class="need-admin__status-plate need-admin__status-plate--user">
                        <Avatar :src="need.user.avatar" :username="need.user.name" :size="20" class="need-admin__status-plate--user__image"/>
                        {{need.user.name}}
                    </span>
                    </td>
                    <td v-if="escalated">
                        <span class="need-admin__status-plate">{{statuses[need.status]}}</span>
                        <!--                    <span class="need-admin__status-plate need-admin__status-plate&#45;&#45;evaluate">Evaluating Solutions</span>-->
                        <!--                    <span class="need-admin__status-plate need-admin__status-plate&#45;&#45;source">Sourcing Solutions</span>-->
                    </td>
                    <td v-if="!escalated">
                        <span v-if="need.recommended_count > 0" class="evaluated-stat">{{ need.recommended_count }}</span>
                    </td>
                    <td>
                        <span v-if="need.from_ai_count > 0" class="evaluated-stat">{{ need.from_ai_count }}</span>
                    </td>
                    <td>
                        <span v-if="need.from_ecosystems_count > 0" class="evaluated-stat">{{ need.from_ecosystems_count }}</span>
                    </td>
                    <td v-if="!escalated">
                        {{ need.rated_count }}
                    </td>
                    <td>
                        <a :href="`/needs/${need.id}`" style="text-decoration: none" :class="escalated ? 'need-admin__review' : 'need-admin__view'" target="_blank">{{ escalated ? 'Review' : 'View' }}</a>
                    </td>
                </tr>

                <!--            <tr>-->
                <!--                <td colspan="6">-->
                <!--                    <div class="need-admin__table__footer">-->
                <!--                        Find more results with AI powered search (premium)-->
                <!--                        <a href="#" class="link">Find More Startups (AI-Powered)</a>-->
                <!--                    </div>-->
                <!--                </td>-->
                <!--            </tr>-->
                </tbody>
            </table>
        </div>

        <div v-else class="text-center">
            Needs not found
        </div>
    </div>


</template>

<style scoped>

</style>
